import React from "react";
import HeroSection from "./components/HeroSection";
import InfoSection from "./components/InfoSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="bg-gray-900 min-h-screen text-forestGreen">
      <HeroSection />
      {/* <InfoSection /> */}
      {/* <Footer /> */}
    </div>
  );
}

export default App;
